const SOURCE_APP = {
  FORMS_APP: 'FORMS_APP',
  LEAD_FLOWS_APP: 'LEAD_FLOWS_APP'
};
export default SOURCE_APP;